import { LookupItemModel } from '../models/lookup-item-model';

export const LOOKUP_FA_ICONS: LookupItemModel<string>[] = [
  'calendar',
  'calendar-alt',
  'calendar-check',
  'calendar-day',
  'calendar-week',
  'calendar-times',
  'clock',
  'hourglass-start',
  'hourglass-half',
  'hourglass-end',
  'stopwatch',
  'tasks',
  'business-time',
  'project-diagram',
  'clipboard-list',
  'clipboard-check',
  'list-alt',
  'edit',
  'pen',
  'highlighter',
  'file-alt',
  'sun',
  'tree',
  'gift',
  'calendar-plus',
  'coffee',
  'smile-beam',
  'shopping-cart',
  'snowflake',
  'star',
  'bolt',
  'water',
  'server',
  'laptop',
  'mobile-alt',
  'desktop',
  'keyboard',
  'mouse',
  'microchip',
  'plug',
  'camera',
  'print',
  'tv',
  'battery-full',
  'network-wired',
  'fan',
  'wind',
  'thermometer-half',
  // IconsArray additions
  'lightbulb',
  'air-conditioner',
  'pump',
  'tank-water',
  'meter-bolt',
  'address-book',
  'address-card',
  'adjust',
  'align-center',
  'align-justify',
  'align-left',
  'align-right',
  'ambulance',
  'anchor',
  'angle-double-down',
  'angle-double-left',
  'angle-double-right',
  'angle-double-up',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-up',
  'archive',
  'arrow-alt-circle-down',
  'arrow-alt-circle-left',
  'arrow-alt-circle-right',
  'arrow-alt-circle-up',
  'arrow-circle-down',
  'arrow-circle-left',
  'arrow-circle-right',
  'arrow-circle-up',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrows-alt',
  'arrows-alt-h',
  'arrows-alt-v',
  'asterisk',
  'at',
  'audio-description',
  'backward',
  'balance-scale',
  'ban',
  'barcode',
  'bars',
  'bath',
  'battery-empty',
  'battery-half',
  'battery-quarter',
  'battery-three-quarters',
  'bed',
  'beer',
  'bell',
  'bell-slash',
  'bicycle',
  'binoculars',
  'birthday-cake',
  'bold',
  'bomb',
  'book',
  'bookmark',
  'briefcase',
  'bug',
  'building',
  'bullhorn',
  'bullseye',
  'bus',
  'blender-phone',
  'calculator',
  'calendar-minus',
  'calendar-times',
  'camera-retro',
  'car',
  'caret-down',
  'cat',
  'caret-left',
  'caret-right',
  'caret-square-down',
  'caret-square-left',
  'caret-square-right',
  'caret-square-up',
  'caret-up',
  'cart-arrow-down',
  'cart-plus',
  'certificate',
  'chart-area',
  'chart-bar',
  'chart-line',
  'chart-pie',
  'check',
  'check-circle',
  'check-square',
  'chevron-circle-down',
  'chevron-circle-left',
  'chevron-circle-right',
  'chevron-circle-up',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'child',
  'circle',
  'circle-notch',
  'clipboard',
  'clone',
  'cloud',
  'cloud-download-alt',
  'cloud-upload-alt',
  'code',
  'code-branch',
  'cog',
  'cogs',
  'columns',
  'comment',
  'comment-alt',
  'compass',
  'compress',
  'computer',
  'cookie',
  'copy',
  'credit-card',
  'crop',
  'crosshairs',
  'cube',
  'cubes',
  'cut',
  'database',
  'download',
  'eject',
  'envelope',
  'elevator',
  'dog',
  'envelope-open',
  'eraser',
  'exchange',
  'exclamation',
  'expand',
  'external-link',
  'eye',
  'eye-slash',
  'fast-backward',
  'fast-forward',
  'fax',
  'file',
  'file-archive',
  'file-audio',
  'file-code',
  'file-excel',
  'file-image',
  'file-pdf',
  'file-powerpoint',
  'file-video',
  'file-word',
  'film',
  'filter',
  'fire',
  'flag',
  'folder',
  'folder-open',
  'font',
  'forward',
  'frown',
  'gamepad',
  'gem',
  'globe',
  'graduation-cap',
  'hamburger',
  'hammer',
  'hand-lizard',
  'hand-paper',
  'hand-peace',
  'hand-point-down',
  'hand-point-left',
  'hand-point-right',
  'hand-point-up',
  'hand-pointer',
  'hand-rock',
  'hand-scissors',
  'hand-spock',
  'hands',
  'hands-helping',
  'handshake',
  'hashtag',
  'hdd',
  'heart',
  'home',
  'hourglass',
  'id-badge',
  'id-card',
  'image',
  'images',
  'inbox',
  'indent',
  'industry',
  'info',
  'info-circle',
  'italic',
  'key',
  'leaf',
  'lemon',
  'level-down-alt',
  'level-up-alt',
  'life-ring',
  'link',
  'list',
  'lock',
  'magic',
  'magnet',
  'map',
  'map-marker',
  'map-pin',
  'map-signs',
  'medkit',
  'meh',
  'microphone',
  'microphone-alt',
  'minus',
  'minus-circle',
  'minus-square',
  'mobile',
  'money-bill',
  'moon',
  'motorcycle',
  'mouse-pointer',
  'music',
  'newspaper',
  'object-group',
  'object-ungroup',
  'outdent',
  'paper-plane',
  'paperclip',
  'paste',
  'pause',
  'pause-circle',
  'paw',
  'pen-alt',
  'pencil-alt',
  'phone',
  'phone-square',
  'phone-volume',
  'plane',
  'play',
  'play-circle',
  'plus',
  'plus-circle',
  'plus-square',
  'podcast',
  'poo',
  'portrait',
  'power-off',
  'puzzle-piece',
  'qrcode',
  'question',
  'question-circle',
  'quote-left',
  'quote-right',
  'random',
  'record-vinyl',
  'redo',
  'redo-alt',
  'reply',
  'reply-all',
  'retweet',
  'road',
  'rocket',
  'rss',
  'rss-square',
  'save',
  'search',
  'search-minus',
  'search-plus',
  'share',
  'share-alt',
  'share-square',
  'shield-alt',
  'ship',
  'shopping-bag',
  'shopping-basket',
  'shower',
  'sign-in-alt',
  'sign-out-alt',
  'signal',
  'sitemap',
  'sliders-h',
  'smile',
  'smoking',
  'sort',
  'sort-alpha-down',
  'sort-alpha-up',
  'sort-amount-down',
  'sort-amount-up',
  'sort-down',
  'sort-numeric-down',
  'sort-numeric-up',
  'sort-up',
  'spa',
  'space-shuttle',
  'spinner',
  'square',
  'star-half',
  'sticky-note',
  'stop',
  'stop-circle',
  'street-view',
  'subway',
  'suitcase',
  'tablet',
  'tag',
  'tags',
  'taxi',
  'terminal',
  'text-height',
  'text-width',
  'th',
  'th-large',
  'th-list',
  'thumbs-down',
  'thumbs-up',
  'thumbtack',
  'ticket-alt',
  'times',
  'times-circle',
  'tint',
  'toggle-off',
  'toggle-on',
  'toolbox',
  'trademark',
  'train',
  'trash',
  'trash-alt',
  'trophy',
  'truck',
  'umbrella',
  'undo',
  'undo-alt',
  'unlink',
  'unlock',
  'unlock-alt',
  'upload',
  'user',
  'user-circle',
  'user-md',
  'user-plus',
  'user-secret',
  'user-times',
  'users',
  'utensil-spoon',
  'utensils',
  'venus',
  'venus-double',
  'venus-mars',
  'video',
  'volume-down',
  'volume-off',
  'volume-up',
  'wallet',
  'wheelchair',
  'wifi',
  'window-close',
  'window-maximize',
  'window-minimize',
  'window-restore',
  'wrench',
  'yen-sign',
  'hand-holding',
  'hand-holding-heart',
  'hand-holding-usd',
  'hand-holding-water',
  'hands-wash',
  'head-side-cough',
  'head-side-cough-slash',
  'head-side-mask',
  'head-side-virus',
  'house-user',
  'laptop-house',
  'laptop-medical',
  'pager',
  'radiation',
  'school',
  'screwdriver',
  'soap',
  'toilet-paper',
  'tools',
  'tooth',
  'temperature-arrow-up',
  'umbrella-beach',
  'vacuum',
  'washing-machine',
  'dryer',
  'oven',
  'refrigerator',
  'blender',
  'shredder',
  // RolesArray additions
  'user-tie',
  'user-cog',
  'user-edit',
  'user-shield',
  'user-lock',
  'user-check',
  'user-tag',
  'user-friends',
  'users-cog',
  'faucet',
  'boxes',
  // ScheduleIconsArray additions
  'hourglass-start',
  'hourglass-half',
  'hourglass-end',
  'stopwatch',
  'business-time',
  'alarm-clock',
  'clipboard-list',
  'clipboard-check',
  'highlighter',
  'file-invoice',
  'file-invoice-dollar',
  'glass-cheers',
  'campground',
  'hiking',
  'mug-hot',
  'thermometer-three-quarters',
  'temperature-low',
  'temperature-high',
  'cloud-sun',
  'cloud-showers-heavy',
  'satellite-dish',
  'broadcast-tower',
  'sim-card',
  'tablet-alt',
].map(icon => new LookupItemModel<string>(icon, icon, `fa-${icon}`));